"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popoverContextPropType = exports.ConsumesPopoverContext = exports.Provider = exports.Consumer = exports.types = void 0;

var _react = require("react");

var _consumerDecoratorFactory = _interopRequireDefault(require("./consumerDecoratorFactory"));

var _Use = require("../tooltip/utils/Use");

var types = {
  use: _react.PropTypes.oneOf(Object.keys(_Use.USE_CLASSES)).isRequired
};
exports.types = types;

var _createContext = (0, _react.createContext)(),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;

exports.Provider = Provider;
exports.Consumer = Consumer;
var ConsumesPopoverContext = (0, _consumerDecoratorFactory.default)('popover', Consumer);
exports.ConsumesPopoverContext = ConsumesPopoverContext;

var popoverContextPropType = _react.PropTypes.shape(types);

exports.popoverContextPropType = popoverContextPropType;